export default __webpack_public_path__ + "static/media/suitcase.ae14f189.svg";